import { render, staticRenderFns } from "./table-pagination.vue?vue&type=template&id=18982903&scoped=true"
import script from "./table-pagination.vue?vue&type=script&lang=js"
export * from "./table-pagination.vue?vue&type=script&lang=js"
import style0 from "./table-pagination.vue?vue&type=style&index=0&id=18982903&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18982903",
  null
  
)

export default component.exports